export const useFeatureFlags = () => {
    return {
        enableInstructorV2: process.env.REACT_APP_ENABLE_INSTRUCTOR_V2 === 'true',
        enableStudentGradesV2: process.env.REACT_APP_ENABLE_STUDENT_GRADES_V2 === 'true',
        enableErrorReportV2: process.env.REACT_APP_ENABLE_ERROR_REPORT_V2 === 'true',
    };
};